import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import * as constand from "../../constant.js";
import { loginModelOpen } from "../../actions/HeaderActions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const ProgramListAccordian = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { programList, index, condition } = props;

  function navigateToProgram(program) {
    const user = localStorage.getItem('user');

    if (!user) {
      dispatch(loginModelOpen(true));
      return;
    }

    if (program.isDynamic) {
      history.push(`/programmes/dashboard/${condition}/${program.id}`);
    } else {
      history.push(`/programmes/detail/${condition}/${program.id}`);
    }
  }

    // Function to get slidesPerView based on screen width
    const getSlidesPerView = () => {
      if (window.innerWidth >= 1000) {
        return 4;
      } else if (window.innerWidth >= 768) {
        return 2.5;
      } else {
        return 1.5;
      }
    };
  
    // Check if navigation should be shown
    const shouldShowNavigation = () => {
      return window.innerWidth >= 1050 && programList.programs.length > getSlidesPerView();
    };

  return (
    <div className="prgmacc demand-section--3 m-t-30">
      <div key={index} className="row position-relative landing_swiper swipernavDetail test mx-0">
        <Swiper
          navigation={
            shouldShowNavigation()
              ? {
                  nextEl: `.swipernavDetail .swiper-button-next-${index}-00`,
                  prevEl: `.swipernavDetail .swiper-button-prev-${index}-00`
                }
              : false
          }
          pagination={
            window.innerWidth < 1050
              ? {
                el: `.swiper-pagination-${index}`,
                clickable: true,
              }
              : false
          }
          modules={[Pagination, Navigation, Autoplay]}
          spaceBetween={30}
          loop={false}
          containerModifierClass="w-100 "
          className="mySwiper"
          breakpoints={{
            1: {
              slidesPerView: 1.5,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 20
            },
            1000: {
              slidesPerView: 4,
              spaceBetween: 20
            }
          }}
        >
          {programList.programs.map((program, index) => (
            <SwiperSlide key={index} className="h-100">
              <div className="program-card d-flex flex-column h-100 rounded-lg overflow-hidden shadow-md cursor-pointer">
                <div className="">
                  <img
                    className="media-object w-100 image-size img-fluid"
                    src={
                      program.img
                        ? constand.S3_URL + "/api/img/program/" + program.img
                        : constand.S3_URL + '/web/images/ondemand-placeholder.png'
                    }
                    alt="img"
                    onClick={() => navigateToProgram(program)}
                  />
                </div>
                <div className="card-content flex-grow-1 d-flex flex-column justify-content-between p-0 pt-3">
                  <h3
                    className="black-txt-light font-16 capitalize_text fw600 mb-0 font-qsemibold"
                    onClick={() => navigateToProgram(program)}
                  >
                    {program.title}
                  </h3>
                  <p
                    className="font-14 font-qregular black-txt-light fw600 w-100 m-t-8 mb-0"
                    onClick={() => navigateToProgram(program)}
                  >
                    {program?.formatDesc}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className={`swiper-pagination swiper-pagination-${index} mt-3 text-center`}></div>
        {/* Navigation arrows (desktop only) */}
        {shouldShowNavigation() && (
          <>
          <div className={`swiper-button-prev-${index}-00 swiper-button-prev d-none d-md-block`}></div>
          <div className={`swiper-button-next-${index}-00 swiper-button-next d-none d-md-block`}></div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProgramListAccordian;